module.exports = __webpack_public_path__ + "static/index/img/baikal-606.d1565e1c.jpg";